export default __webpack_public_path__ + "static/gospel-0730be9da392608d5dd26da272326c45.jpg";